import { StudioManager } from "../studio-manager";

const endpoint = 'https://kioskradiobxl.airtime.pro/api/live-info-v2';

export class Airtime {
  constructor () {
    this.isPlaying = false;
    this.show = '';
  }

  init () {
    this.player = document.getElementById('airtime');
  }

  loadMeta () {
    return new Promise((resolve, reject) => {
      window.fetch(endpoint).then(response => response.json()).then(data => {
        if (!data.shows.current) return;
        this.show = data.shows.current.name + data.tracks.current.name;
        resolve(this.show);
      }).catch(reject);
    })
  }

  play = () => {
    if (StudioManager.instance.widget) StudioManager.instance.widget.stop();

    this.isPlaying = true;
    this.player.play();
    return 'airtime-play';
  }

  stop = () => {
    this.isPlaying = false;
    this.player.pause();
    return 'airtime-stop';
  }

  toggle () {
    return this.isPlaying ? this.stop() : this.play();
  }
}
